"use strict";
/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockDeltaManager = exports.MockDeltaQueue = void 0;
const events_1 = require("events");
const common_utils_1 = require("@fluidframework/common-utils");
/**
 * Mock implementation of IDeltaQueue for testing that does nothing
 */
class MockDeltaQueue extends events_1.EventEmitter {
    constructor() {
        super();
        this.queue = [];
        this.pauseCount = 0;
        this.processCallback = () => { };
    }
    get disposed() { return undefined; }
    get paused() {
        return this.pauseCount !== 0;
    }
    get length() { return this.queue.length; }
    get idle() {
        return this.queue.length === 0;
    }
    process() {
        void Promise.resolve().then(() => {
            while (this.pauseCount === 0 && this.length > 0) {
                const el = this.pop();
                (0, common_utils_1.assert)(el !== undefined, "this is impossible due to the above length check");
                this.processCallback(el);
            }
        });
    }
    push(el) {
        this.queue.push(el);
        this.emit("push", el);
        this.process();
    }
    pop() {
        return this.queue.shift();
    }
    async pause() {
        this.pauseCount++;
        return;
    }
    resume() {
        this.pauseCount--;
        this.process();
    }
    peek() {
        return this.queue[0];
    }
    toArray() {
        return this.queue;
    }
    dispose() { }
    async waitTillProcessingDone() {
        throw new Error("NYI");
    }
}
exports.MockDeltaQueue = MockDeltaQueue;
/**
 * Mock implementation of IDeltaManager for testing that creates mock DeltaQueues for testing
 */
class MockDeltaManager extends common_utils_1.TypedEventEmitter {
    constructor() {
        super();
        this.readOnlyInfo = { readonly: false };
        this.clientType = undefined;
        this.clientDetails = undefined;
        this._inbound = undefined;
        this._inboundSignal = undefined;
        this._outbound = undefined;
        this.minimumSequenceNumber = 0;
        this.lastSequenceNumber = 0;
        this.lastKnownSeqNumber = 0;
        this.initialSequenceNumber = 0;
        this.hasCheckpointSequenceNumber = false;
        this._inbound = new MockDeltaQueue();
        this._outbound = new MockDeltaQueue();
        this._inboundSignal = new MockDeltaQueue();
    }
    get disposed() { return undefined; }
    get IDeltaSender() { return this; }
    get inbound() {
        return this._inbound;
    }
    get outbound() {
        return this._outbound;
    }
    get inboundSignal() {
        return this._inboundSignal;
    }
    get version() {
        return undefined;
    }
    get maxMessageSize() {
        return 0;
    }
    get serviceConfiguration() {
        return undefined;
    }
    get active() {
        return true;
    }
    close() { }
    submitSignal(content) { }
    flush() { }
    submit(type, contents, batch = false, localOpMetadata) {
        return 0;
    }
    dispose() { }
}
exports.MockDeltaManager = MockDeltaManager;
//# sourceMappingURL=mockDeltas.js.map